module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("58VJf"))).then(() => parcelRequire('1iHdE'));